export function showFixedMenu() {
	const $menu = $('.js-menu');
	if (window.pageYOffset > 1) {
		$menu[0].classList.add('menu-fixed');
	} else {
		$menu[0].classList.remove('menu-fixed');
	}
}

export function showDevForm(title, text, idForm = '#detail-info') {
	const form = $(idForm);

	form.find('.popup__title')[0].innerText = title;
	form.find('.popup__text')[0].innerHTML = text;

	$('.popup')[0].classList.add('is-active');
	form[0].classList.add('is-active');
}

export function hideForm() {
	$('.popup__wrapper').each((i, el) => {
		const $el = $(el)[0].classList;
		const $popup = $('.popup')[0].classList;

		if ($popup.contains('is-active')) {
			$popup.remove('is-active');
		}
		if ($el.contains('is-active')) {
			$el.remove('is-active');
		}
	});
}

export function updateThumbnail(dropZoneElement, file) {
	const thumbnailElement = document.querySelector('.js-form-filename');
	const mobileElement = document.querySelector('.welcome-form-file__label-mobile span');

	if (dropZoneElement.querySelector('.drop-zone__prompt')) {
		dropZoneElement.querySelector('.drop-zone__prompt').remove();
	}

	const filename = file.name;
	if (filename.length >= 30) {
		thumbnailElement.textContent = `${filename.substr(0, 27)}...`;
	} else {
		thumbnailElement.textContent = filename;
	}

	mobileElement.textContent = 'Файл загружен';
}

export function toggleIcon() {
	const beforeLoad = document.querySelector('.js-upload');
	const afterLoad = document.querySelector('.js-document');

	beforeLoad.classList.toggle('is-hidden');
	afterLoad.classList.toggle('is-hidden');
}
